/* tslint:disable */

declare var Object: any;
export interface OrderItemInterface {
  "orderId": string;
  "partnerId": string;
  "productType": string;
  "planType": string;
  "quantity": number;
  "unitPrice": number;
  "unitDiscount": number;
  "discountUnit": string;
  "unitVolumeDiscount": number;
  "volumeDiscountUnit": string;
  "subTotal": number;
  "totalAmount": number;
  "totalDiscount": number;
  "totalVolumeDiscount": number;
  "unitTax": number;
  "totalTax": number;
  "totalVat"?: number;
  "netOfVat"?: number;
  "accountingDocument"?: string;
  "SOANumber"?: string;
  "SOADate"?: Date;
  "id"?: number;
  order?: any;
  commissions?: any[];
}

export class OrderItem implements OrderItemInterface {
  "orderId": string;
  "partnerId": string;
  "productType": string;
  "planType": string;
  "quantity": number;
  "unitPrice": number;
  "unitDiscount": number;
  "discountUnit": string;
  "unitVolumeDiscount": number;
  "volumeDiscountUnit": string;
  "subTotal": number;
  "totalAmount": number;
  "totalDiscount": number;
  "totalVolumeDiscount": number;
  "unitTax": number;
  "totalTax": number;
  "totalVat": number;
  "netOfVat": number;
  "accountingDocument": string;
  "SOANumber": string;
  "SOADate": Date;
  "id": number;
  order: any;
  commissions: any[];
  constructor(data?: OrderItemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `OrderItem`.
   */
  public static getModelName() {
    return "OrderItem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of OrderItem for dynamic purposes.
  **/
  public static factory(data: OrderItemInterface): OrderItem{
    return new OrderItem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'OrderItem',
      plural: 'OrderItems',
      path: 'OrderItems',
      idName: 'id',
      properties: {
        "orderId": {
          name: 'orderId',
          type: 'string'
        },
        "partnerId": {
          name: 'partnerId',
          type: 'string'
        },
        "productType": {
          name: 'productType',
          type: 'string'
        },
        "planType": {
          name: 'planType',
          type: 'string'
        },
        "quantity": {
          name: 'quantity',
          type: 'number',
          default: 0
        },
        "unitPrice": {
          name: 'unitPrice',
          type: 'number',
          default: 0
        },
        "unitDiscount": {
          name: 'unitDiscount',
          type: 'number',
          default: 0
        },
        "discountUnit": {
          name: 'discountUnit',
          type: 'string',
          default: 'P'
        },
        "unitVolumeDiscount": {
          name: 'unitVolumeDiscount',
          type: 'number',
          default: 0
        },
        "volumeDiscountUnit": {
          name: 'volumeDiscountUnit',
          type: 'string',
          default: 'P'
        },
        "subTotal": {
          name: 'subTotal',
          type: 'number',
          default: 0
        },
        "totalAmount": {
          name: 'totalAmount',
          type: 'number',
          default: 0
        },
        "totalDiscount": {
          name: 'totalDiscount',
          type: 'number',
          default: 0
        },
        "totalVolumeDiscount": {
          name: 'totalVolumeDiscount',
          type: 'number',
          default: 0
        },
        "unitTax": {
          name: 'unitTax',
          type: 'number',
          default: 0
        },
        "totalTax": {
          name: 'totalTax',
          type: 'number',
          default: 0
        },
        "totalVat": {
          name: 'totalVat',
          type: 'number',
          default: 0
        },
        "netOfVat": {
          name: 'netOfVat',
          type: 'number',
          default: 0
        },
        "accountingDocument": {
          name: 'accountingDocument',
          type: 'string'
        },
        "SOANumber": {
          name: 'SOANumber',
          type: 'string'
        },
        "SOADate": {
          name: 'SOADate',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        order: {
          name: 'order',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'orderId',
          keyTo: 'id'
        },
        commissions: {
          name: 'commissions',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'orderItemId'
        },
      }
    }
  }
}
